module.exports = __webpack_public_path__ + "img/cs-bottom-image.4b41e9e3.svg";